var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_353_4768)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3229,
    y: 21.3229,
    width: 182.562,
    height: 124.354,
    rx: 14.5521,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2.64583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78 123.187C141.404 123.287 160.229 106.213 160.229 85.4422C160.229 62.7302 141.404 47.0294 120.78 47.0378H103.03C82.1593 47.0294 64.9791 62.7345 64.9791 85.4422C64.9791 106.217 82.1593 123.287 103.03 123.187H120.78Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.114 50.1848C84.0415 50.1912 68.5886 65.7903 68.5823 85.0433C68.5886 104.294 84.0415 119.893 103.114 119.9C122.189 119.893 137.649 104.294 137.651 85.0433C137.649 65.7903 122.192 50.1912 103.114 50.1848ZM81.2269 85.0433C81.2229 80.5919 82.5619 76.2427 85.0688 72.5643C87.5758 68.8859 91.1341 66.0494 95.2788 64.4254V105.659C91.1338 104.036 87.575 101.2 85.0679 97.5221C82.5608 93.8439 81.2221 89.4947 81.2269 85.0433V85.0433ZM110.948 105.668V64.4232C115.096 66.0449 118.657 68.8812 121.166 72.5609C123.675 76.2405 125.014 80.5919 125.008 85.0455C125.013 89.4988 123.673 93.8498 121.165 97.5293C118.656 101.209 115.095 104.045 110.948 105.668V105.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78 123.187C141.404 123.287 160.229 106.213 160.229 85.4422C160.229 62.7302 141.404 47.0294 120.78 47.0378H103.03C82.1593 47.0294 64.9791 62.7345 64.9791 85.4422C64.9791 106.217 82.1593 123.287 103.03 123.187H120.78Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.114 50.1848C84.0415 50.1912 68.5886 65.7903 68.5823 85.0433C68.5886 104.294 84.0415 119.893 103.114 119.9C122.189 119.893 137.649 104.294 137.651 85.0433C137.649 65.7903 122.192 50.1912 103.114 50.1848ZM81.2269 85.0433C81.2229 80.5919 82.5619 76.2427 85.0688 72.5643C87.5758 68.8859 91.1341 66.0494 95.2788 64.4254V105.659C91.1338 104.036 87.575 101.2 85.0679 97.5221C82.5608 93.8439 81.2221 89.4947 81.2269 85.0433V85.0433ZM110.948 105.668V64.4232C115.096 66.0449 118.657 68.8812 121.166 72.5609C123.675 76.2405 125.014 80.5919 125.008 85.0455C125.013 89.4988 123.673 93.8498 121.165 97.5293C118.656 101.209 115.095 104.045 110.948 105.668V105.668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_353_4768",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_353_4768",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.d585ec7a871f6c1d3bbddd49fc7a441d.svg";
export { ForwardRef as ReactComponent };